var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "top-toolbox",
        class: { "timer-trigger": _vm.automation.options.trigger === "timer" },
      },
      [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.selectedTab === "action-palette" },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleSelectedTab("action-palette")
                },
              },
            },
            [_c("md-icon", [_vm._v("bolt")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.selectedTab === "search" },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleSelectedTab("search")
                },
              },
            },
            [_c("md-icon", [_vm._v("search")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: "Cache Yönetimi" },
                  expression: "{ content: 'Cache Yönetimi' }",
                },
              ],
              staticClass: "chatbot-btn",
              class: { selected: _vm.selectedTab === "cache" },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleSelectedTab("cache")
                },
              },
            },
            [_c("md-icon", [_vm._v("storage")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.selectedTab === "settings" },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleSelectedTab("settings")
                },
              },
            },
            [_c("md-icon", [_vm._v("settings")])],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "", disabled: _vm.previewMode },
                on: {
                  click: function () {
                    return _vm.startTest()
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "d-flex justify-content-between align-content-center align-items-center",
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("not_started"),
                    ]),
                    _vm._v(" "),
                    _c("b", { staticClass: "ml-2" }, [
                      _vm._v(_vm._s(_vm.$t("automation.startTest"))),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.checkPermission(
              _vm.PERMISSION_TYPES["chatbot.stories.update"].tr.name
            )
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: !_vm.automation.published,
                      danger: _vm.automation.published,
                      disabled: _vm.previewMode,
                    },
                    on: {
                      click: function () {
                        return _vm.automation.published
                          ? _vm.unPublishAutomation()
                          : _vm.publishAutomation()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-flex justify-content-between align-content-center align-items-center",
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("send"),
                        ]),
                        _vm._v(" "),
                        _vm.automation.published
                          ? _c("b", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.$t("automation.unpublish"))),
                            ])
                          : _c("b", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.publish"))),
                            ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _vm.selectedTab !== 0
      ? _c(
          "div",
          { staticClass: "side-bar" },
          [
            _vm.selectedTab === "action-palette"
              ? _c("ActionPalette", {
                  attrs: {
                    dragMode: _vm.dragMode,
                    dragStart: _vm.dragStart,
                    dragEnd: _vm.dragEnd,
                    addBlockToDiagram: _vm.addBlockToDiagram,
                    bar: _vm.selectedTab,
                  },
                  on: {
                    "close-menu": function ($event) {
                      _vm.selectedTab = $event
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.previewMode && _vm.selectedTab === "search"
              ? _c("SearchWidget", {
                  attrs: {
                    blocksMetas: _vm.blocksMetas,
                    flattedDiagram: _vm.flattedDiagram,
                    toggleSelectedTab: _vm.toggleSelectedTab,
                    bar: _vm.selectedTab,
                    automation: _vm.automation,
                    navigateTo: _vm.navigateTo,
                  },
                  on: {
                    focusBlock: _vm.focusBlock,
                    "close-menu": function ($event) {
                      _vm.selectedTab = $event
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.previewMode && _vm.selectedTab === "settings"
              ? _c("SettingsWidget", {
                  attrs: { bar: _vm.selectedTab, automation: _vm.automation },
                  on: {
                    "close-menu": function ($event) {
                      _vm.selectedTab = $event
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.previewMode && _vm.selectedTab === "debugger"
              ? _c("AutomationDebugger", {
                  attrs: {
                    bar: _vm.selectedTab,
                    automation: _vm.automation,
                    testStartBlockId: _vm.testStartBlockId,
                  },
                  on: {
                    "close-menu": function ($event) {
                      _vm.selectedTab = $event
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.previewMode && _vm.selectedTab === "cache"
              ? _c("CacheWidget", {
                  attrs: { bar: _vm.selectedTab, automation: _vm.automation },
                  on: {
                    "close-menu": function ($event) {
                      _vm.selectedTab = $event
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }